export default __webpack_public_path__ + "static/media/Gamausados.24acfcae.webp";